import { Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-upgrade-to-premium-overlay',
  imports: [RouterLink],
  templateUrl: './upgrade-to-premium-overlay.component.html',
})
export class UpgradeToPremiumOverlayComponent {
  type = input.required<string>();

  isSubCardUpgrade = computed(() => this.type() === 'subscription-card');
  isIntegrationUpgrade = computed(() => this.type() === 'integration');
}
